// extracted by mini-css-extract-plugin
export var locationCard = "_hc-0";